<template>
    <Head :title="$t('auth.invalidInvite')" />

    <jet-authentication-card class="bg-minplan-blue" :style="branding?.branding_navbar_color ? { backgroundColor: branding.branding_navbar_color } : {}">
        <template #logo>
            <img v-if="branding?.branding_logo_url" class="h-16 w-auto" :src="branding.branding_logo_url" alt="immivo" />
            <img v-else class="h-16 w-auto" src="../../../image/immivo.svg" alt="immivo" />
        </template>

        <div class="mb-4 text-sm text-gray-600">
            {{ $t("auth.invalidInvite") }}
        </div>
        <Link
            :href="route('login')"
            class="underline text-sm text-gray-600 hover:text-gray-900"
        >
            {{ $t("auth.login") }}
        </Link>

    </jet-authentication-card>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "@/Jetstream/AuthenticationCardLogo.vue";
import PrimaryButton from "@/Jetstream/PrimaryButton.vue";

export default {
    components: {
        Link,
        PrimaryButton,
        Head,
        JetAuthenticationCard,
        JetAuthenticationCardLogo
    },
    props: ["branding"],
    methods: {
        toLogin() {
            this.$inertia.link()
        }
    }
};
</script>

<style scoped></style>
